// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatawokb } from "../../../icons/mono/build/icon-statawokb.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatawokbIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatawokb.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatawokbIcon.displayName = 'StatawokbIcon';
}

export default StatawokbIcon;